import { useContext } from 'react';

import { useAnalytics } from '@atlassian/ptc-common';

import AppConfigContext from './AppConfigContext';
import type { AnalyticsEventProps, Flag } from './types';

export const useFlags = () => {
	const { addFlag } = useContext(AppConfigContext);
	const analytics = useAnalytics();

	const addFlagWithAnalytics = (flag: Flag, analyticsEvent?: AnalyticsEventProps) => {
		if (analyticsEvent?.sendAnalytics) {
			analytics.pushScreenEvent({
				name: analyticsEvent.name,
			});
		}

		addFlag(flag);
	};
	return addFlagWithAnalytics;
};
